import { MaskedTextHighlight } from "./MaskedTextHighlight";
import { resolveGraphic } from "../lib/textures";
import { getHighlight } from "../lib/highlightConfig";

// Renders `text` with a texture highlight when the given page/target is active
// in the config, otherwise renders `fallback` (or plain text). Reusable on any page.
export function HighlightedText({
  pageHighlights,
  page,
  target,
  text,
  as = "p",
  className = "",
  fallback = null,
}) {
  const h = getHighlight(pageHighlights, page, target);
  if (!h) {
    if (fallback !== null) return fallback;
    const Tag = as;
    return <Tag className={className}>{text}</Tag>;
  }
  const rg = resolveGraphic({ variant: "texture", texture_id: h.texture_id, opacity: 0.8, radius: 8 });
  return (
    <MaskedTextHighlight
      text={text}
      graphic={rg}
      as={as}
      shape="block"
      className={className}
      textColor={rg.autoTextColor || "#52525B"}
      textShadow={rg.autoTextShadow || "none"}
    />
  );
}
